module.exports = __webpack_public_path__ + "static/media/08A.1bf3a984.png";